import colors from '@utils/colors';
import styled from 'styled-components';

const BetaBadge = styled.span`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  color: ${colors.primaryPurple};
  background-color: ${colors.primaryPurple}22;
  line-height: 1.4;
  flex-shrink: 0;
`;

export default BetaBadge;
